<template>
    <div>
        <div class="elasticsearchMonitor-title">
            <div>Elasticsearch</div>
            <div>
                <Button type="primary" @click="addOrUpdateHandle" v-hasPermission="['monitor:elasticsearchMonitor:add_alert_rule']">{{ $t('ElasticSearch.addEs') }}</Button>
                <add-or-update-elasticsearch-warning v-if="addOrUpdateVisible" ref="addOrUpdate"></add-or-update-elasticsearch-warning>
            </div>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('alarms.elasticSearch.elasticSearchList')">
                    <div class="elasticsearchMonitor-top">
                        <elasticsearch-monitor-search></elasticsearch-monitor-search>
                    </div>
                    <table-elasticsearch></table-elasticsearch>
                </TabPane>
            </Tabs>
        </template>

    </div>
</template>

<script>
    import ElasticsearchMonitorSearch from '../es/ElasticsearchMonitorSearch'
    import TableElasticsearch from '../es/TableElasticsearch'
    import AddOrUpdateElasticsearchWarning from '../es/AddOrUpdateElasticsearchWarning'

    export default {
        name: 'ElasticsearchMonitor',
        components: {
            ElasticsearchMonitorSearch,
            TableElasticsearch,
            AddOrUpdateElasticsearchWarning
        },
        data(){
            return {
                addOrUpdateVisible:false
            }
        },
         methods:{
            // 添加报警规则
            /**********************************************************************************/
            addOrUpdateHandle:function(){
                this.addOrUpdateVisible=true;
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init()
                })
            }
        }
    }
</script>

<style scoped>
    .elasticsearchMonitor-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 0px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .elasticsearchMonitor-title>div:nth-child(1)
    {
        float:left;
    }
    .elasticsearchMonitor-title>div:nth-child(2)
    {
        float:right;
        margin-top: -6px;
    }
    .elasticsearchMonitor-top
    {
        width: 100%;
        height: 32px;
        margin-bottom: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/es/ElasticsearchMonitor.vue